{
	"ariaDismissBrowserWarning": "Dismiss Browser Warning",
	"ariaDownloadDesktopApp": "Download Desktop App",
	"ariaDownloadGoogleChrome": "Download Google Chrome",
	"gotIt": "Got it",
	"installDesktopApp": "Install Desktop App",
	"installGoogleChrome": "Install Google Chrome",
	"switchToChrome": "Switch to Chrome or download our app",
	"defaultBodyText": "Your current browser is not compatible. Pixieset Photo Editor works best in Chrome or our desktop app."
}
